/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Address,
  Contract,
  ContractState,
  TestContractResult,
  HexString,
  ContractFactory,
  EventSubscribeOptions,
  EventSubscription,
  CallContractParams,
  CallContractResult,
  TestContractParams,
  ContractEvent,
  subscribeContractEvent,
  subscribeContractEvents,
  testMethod,
  callMethod,
  multicallMethods,
  fetchContractState,
  Asset,
  ContractInstance,
  getContractEventsCurrentCount,
  TestContractParamsWithoutMaps,
  TestContractResultWithoutMaps,
  SignExecuteContractMethodParams,
  SignExecuteScriptTxResult,
  signExecuteMethod,
  addStdIdToFields,
  encodeContractFields,
  Narrow,
} from "@alephium/web3";
import { default as LiquidityManagmentTestContractJson } from "../LiquidityManagmentTest.ral.json";
import { getContractByCodeHash, registerContract } from "./contracts";
import * as types from "./types";

// Custom types for the contract
export namespace LiquidityManagmentTestTypes {
  export type Fields = {
    parent: HexString;
  };

  export type State = ContractState<Fields>;

  export interface CallMethodTable {
    addLiquidity: {
      params: CallContractParams<{
        payer: Address;
        p: types.ModifyLiquidityParams;
      }>;
      result: CallContractResult<[bigint, bigint, bigint, HexString]>;
    };
    getLiquidityForAmount0: {
      params: CallContractParams<{
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        amount0: bigint;
      }>;
      result: CallContractResult<bigint>;
    };
    getLiquidityForAmount1: {
      params: CallContractParams<{
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        amount1: bigint;
      }>;
      result: CallContractResult<bigint>;
    };
    getLiquidityForAmounts: {
      params: CallContractParams<{
        sqrtRatioX96: bigint;
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        amount0: bigint;
        amount1: bigint;
      }>;
      result: CallContractResult<bigint>;
    };
    getAmount0ForLiquidity: {
      params: CallContractParams<{
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        liquidity: bigint;
      }>;
      result: CallContractResult<bigint>;
    };
    mulDiv: {
      params: CallContractParams<{ a: bigint; b: bigint; denominator: bigint }>;
      result: CallContractResult<bigint>;
    };
    mulDivRoundingUp: {
      params: CallContractParams<{ a: bigint; b: bigint; denominator: bigint }>;
      result: CallContractResult<bigint>;
    };
    configPath: {
      params: CallContractParams<{ configIndex_: bigint }>;
      result: CallContractResult<HexString>;
    };
    poolPath: {
      params: CallContractParams<{
        factory: HexString;
        tokens: HexString;
        configIndex_: bigint;
      }>;
      result: CallContractResult<HexString>;
    };
    poolContractId: {
      params: CallContractParams<{
        factory: HexString;
        tokens: HexString;
        configIndex_: bigint;
      }>;
      result: CallContractResult<HexString>;
    };
    positionPath: {
      params: CallContractParams<{
        o: Address;
        tickLower: bigint;
        tickUpper: bigint;
      }>;
      result: CallContractResult<HexString>;
    };
    positionContractId: {
      params: CallContractParams<{
        pool: HexString;
        o: Address;
        tickLower: bigint;
        tickUpper: bigint;
      }>;
      result: CallContractResult<HexString>;
    };
    getSqrtRatioAtTick: {
      params: CallContractParams<{ tick: bigint }>;
      result: CallContractResult<bigint>;
    };
    getTickAtSqrtRatio: {
      params: CallContractParams<{ sqrtPriceX96: bigint }>;
      result: CallContractResult<bigint>;
    };
  }
  export type CallMethodParams<T extends keyof CallMethodTable> =
    CallMethodTable[T]["params"];
  export type CallMethodResult<T extends keyof CallMethodTable> =
    CallMethodTable[T]["result"];
  export type MultiCallParams = Partial<{
    [Name in keyof CallMethodTable]: CallMethodTable[Name]["params"];
  }>;
  export type MultiCallResults<T extends MultiCallParams> = {
    [MaybeName in keyof T]: MaybeName extends keyof CallMethodTable
      ? CallMethodTable[MaybeName]["result"]
      : undefined;
  };
  export type MulticallReturnType<Callss extends MultiCallParams[]> = {
    [index in keyof Callss]: MultiCallResults<Callss[index]>;
  };

  export interface SignExecuteMethodTable {
    addLiquidity: {
      params: SignExecuteContractMethodParams<{
        payer: Address;
        p: types.ModifyLiquidityParams;
      }>;
      result: SignExecuteScriptTxResult;
    };
    getLiquidityForAmount0: {
      params: SignExecuteContractMethodParams<{
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        amount0: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    getLiquidityForAmount1: {
      params: SignExecuteContractMethodParams<{
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        amount1: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    getLiquidityForAmounts: {
      params: SignExecuteContractMethodParams<{
        sqrtRatioX96: bigint;
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        amount0: bigint;
        amount1: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    getAmount0ForLiquidity: {
      params: SignExecuteContractMethodParams<{
        sqrtRatioAX96: bigint;
        sqrtRatioBX96: bigint;
        liquidity: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    mulDiv: {
      params: SignExecuteContractMethodParams<{
        a: bigint;
        b: bigint;
        denominator: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    mulDivRoundingUp: {
      params: SignExecuteContractMethodParams<{
        a: bigint;
        b: bigint;
        denominator: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    configPath: {
      params: SignExecuteContractMethodParams<{ configIndex_: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    poolPath: {
      params: SignExecuteContractMethodParams<{
        factory: HexString;
        tokens: HexString;
        configIndex_: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    poolContractId: {
      params: SignExecuteContractMethodParams<{
        factory: HexString;
        tokens: HexString;
        configIndex_: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    positionPath: {
      params: SignExecuteContractMethodParams<{
        o: Address;
        tickLower: bigint;
        tickUpper: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    positionContractId: {
      params: SignExecuteContractMethodParams<{
        pool: HexString;
        o: Address;
        tickLower: bigint;
        tickUpper: bigint;
      }>;
      result: SignExecuteScriptTxResult;
    };
    getSqrtRatioAtTick: {
      params: SignExecuteContractMethodParams<{ tick: bigint }>;
      result: SignExecuteScriptTxResult;
    };
    getTickAtSqrtRatio: {
      params: SignExecuteContractMethodParams<{ sqrtPriceX96: bigint }>;
      result: SignExecuteScriptTxResult;
    };
  }
  export type SignExecuteMethodParams<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["params"];
  export type SignExecuteMethodResult<T extends keyof SignExecuteMethodTable> =
    SignExecuteMethodTable[T]["result"];
}

class Factory extends ContractFactory<
  LiquidityManagmentTestInstance,
  LiquidityManagmentTestTypes.Fields
> {
  encodeFields(fields: LiquidityManagmentTestTypes.Fields) {
    return encodeContractFields(
      addStdIdToFields(this.contract, fields),
      this.contract.fieldsSig,
      types.AllStructs
    );
  }

  consts = {
    LiquidityManagmentError: {
      MintSlippage: BigInt("850"),
      BurnSlippage: BigInt("851"),
    },
    FullMathError: { MulDivOverflow: BigInt("351") },
    PathPrefixes: {
      Tick: BigInt("0"),
      Position: BigInt("1"),
      Word: BigInt("2"),
    },
    TickMathError: {
      SqrtPriceX96OutOfBounds: BigInt("201"),
      TickOutOfBounds: BigInt("202"),
    },
  };

  at(address: string): LiquidityManagmentTestInstance {
    return new LiquidityManagmentTestInstance(address);
  }

  tests = {
    addLiquidity: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { payer: Address; p: types.ModifyLiquidityParams }
      >
    ): Promise<
      TestContractResultWithoutMaps<[bigint, bigint, bigint, HexString]>
    > => {
      return testMethod(this, "addLiquidity", params, getContractByCodeHash);
    },
    getLiquidityForAmount0: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { sqrtRatioAX96: bigint; sqrtRatioBX96: bigint; amount0: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getLiquidityForAmount0",
        params,
        getContractByCodeHash
      );
    },
    getLiquidityForAmount1: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { sqrtRatioAX96: bigint; sqrtRatioBX96: bigint; amount1: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getLiquidityForAmount1",
        params,
        getContractByCodeHash
      );
    },
    getLiquidityForAmounts: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        {
          sqrtRatioX96: bigint;
          sqrtRatioAX96: bigint;
          sqrtRatioBX96: bigint;
          amount0: bigint;
          amount1: bigint;
        }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getLiquidityForAmounts",
        params,
        getContractByCodeHash
      );
    },
    getAmount0ForLiquidity: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { sqrtRatioAX96: bigint; sqrtRatioBX96: bigint; liquidity: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getAmount0ForLiquidity",
        params,
        getContractByCodeHash
      );
    },
    mulDiv: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { a: bigint; b: bigint; denominator: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(this, "mulDiv", params, getContractByCodeHash);
    },
    mulDivRoundingUp: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { a: bigint; b: bigint; denominator: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "mulDivRoundingUp",
        params,
        getContractByCodeHash
      );
    },
    configPath: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { configIndex_: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "configPath", params, getContractByCodeHash);
    },
    poolPath: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { factory: HexString; tokens: HexString; configIndex_: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "poolPath", params, getContractByCodeHash);
    },
    poolContractId: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { factory: HexString; tokens: HexString; configIndex_: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "poolContractId", params, getContractByCodeHash);
    },
    positionPath: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { o: Address; tickLower: bigint; tickUpper: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(this, "positionPath", params, getContractByCodeHash);
    },
    positionContractId: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { pool: HexString; o: Address; tickLower: bigint; tickUpper: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<HexString>> => {
      return testMethod(
        this,
        "positionContractId",
        params,
        getContractByCodeHash
      );
    },
    getSqrtRatioAtTick: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { tick: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getSqrtRatioAtTick",
        params,
        getContractByCodeHash
      );
    },
    getTickAtSqrtRatio: async (
      params: TestContractParamsWithoutMaps<
        LiquidityManagmentTestTypes.Fields,
        { sqrtPriceX96: bigint }
      >
    ): Promise<TestContractResultWithoutMaps<bigint>> => {
      return testMethod(
        this,
        "getTickAtSqrtRatio",
        params,
        getContractByCodeHash
      );
    },
  };

  stateForTest(
    initFields: LiquidityManagmentTestTypes.Fields,
    asset?: Asset,
    address?: string
  ) {
    return this.stateForTest_(initFields, asset, address, undefined);
  }
}

// Use this object to test and deploy the contract
export const LiquidityManagmentTest = new Factory(
  Contract.fromJson(
    LiquidityManagmentTestContractJson,
    "",
    "8824caa1efe83247812dfa7f32a80ae3d4603937df2b062437581ac421fa817d",
    types.AllStructs
  )
);
registerContract(LiquidityManagmentTest);

// Use this class to interact with the blockchain
export class LiquidityManagmentTestInstance extends ContractInstance {
  constructor(address: Address) {
    super(address);
  }

  async fetchState(): Promise<LiquidityManagmentTestTypes.State> {
    return fetchContractState(LiquidityManagmentTest, this);
  }

  view = {
    addLiquidity: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"addLiquidity">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"addLiquidity">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "addLiquidity",
        params,
        getContractByCodeHash
      );
    },
    getLiquidityForAmount0: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"getLiquidityForAmount0">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"getLiquidityForAmount0">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "getLiquidityForAmount0",
        params,
        getContractByCodeHash
      );
    },
    getLiquidityForAmount1: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"getLiquidityForAmount1">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"getLiquidityForAmount1">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "getLiquidityForAmount1",
        params,
        getContractByCodeHash
      );
    },
    getLiquidityForAmounts: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"getLiquidityForAmounts">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"getLiquidityForAmounts">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "getLiquidityForAmounts",
        params,
        getContractByCodeHash
      );
    },
    getAmount0ForLiquidity: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"getAmount0ForLiquidity">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"getAmount0ForLiquidity">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "getAmount0ForLiquidity",
        params,
        getContractByCodeHash
      );
    },
    mulDiv: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"mulDiv">
    ): Promise<LiquidityManagmentTestTypes.CallMethodResult<"mulDiv">> => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "mulDiv",
        params,
        getContractByCodeHash
      );
    },
    mulDivRoundingUp: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"mulDivRoundingUp">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"mulDivRoundingUp">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "mulDivRoundingUp",
        params,
        getContractByCodeHash
      );
    },
    configPath: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"configPath">
    ): Promise<LiquidityManagmentTestTypes.CallMethodResult<"configPath">> => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "configPath",
        params,
        getContractByCodeHash
      );
    },
    poolPath: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"poolPath">
    ): Promise<LiquidityManagmentTestTypes.CallMethodResult<"poolPath">> => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "poolPath",
        params,
        getContractByCodeHash
      );
    },
    poolContractId: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"poolContractId">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"poolContractId">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "poolContractId",
        params,
        getContractByCodeHash
      );
    },
    positionPath: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"positionPath">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"positionPath">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "positionPath",
        params,
        getContractByCodeHash
      );
    },
    positionContractId: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"positionContractId">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"positionContractId">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "positionContractId",
        params,
        getContractByCodeHash
      );
    },
    getSqrtRatioAtTick: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"getSqrtRatioAtTick">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"getSqrtRatioAtTick">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "getSqrtRatioAtTick",
        params,
        getContractByCodeHash
      );
    },
    getTickAtSqrtRatio: async (
      params: LiquidityManagmentTestTypes.CallMethodParams<"getTickAtSqrtRatio">
    ): Promise<
      LiquidityManagmentTestTypes.CallMethodResult<"getTickAtSqrtRatio">
    > => {
      return callMethod(
        LiquidityManagmentTest,
        this,
        "getTickAtSqrtRatio",
        params,
        getContractByCodeHash
      );
    },
  };

  transact = {
    addLiquidity: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"addLiquidity">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"addLiquidity">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "addLiquidity",
        params
      );
    },
    getLiquidityForAmount0: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"getLiquidityForAmount0">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"getLiquidityForAmount0">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "getLiquidityForAmount0",
        params
      );
    },
    getLiquidityForAmount1: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"getLiquidityForAmount1">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"getLiquidityForAmount1">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "getLiquidityForAmount1",
        params
      );
    },
    getLiquidityForAmounts: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"getLiquidityForAmounts">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"getLiquidityForAmounts">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "getLiquidityForAmounts",
        params
      );
    },
    getAmount0ForLiquidity: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"getAmount0ForLiquidity">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"getAmount0ForLiquidity">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "getAmount0ForLiquidity",
        params
      );
    },
    mulDiv: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"mulDiv">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"mulDiv">
    > => {
      return signExecuteMethod(LiquidityManagmentTest, this, "mulDiv", params);
    },
    mulDivRoundingUp: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"mulDivRoundingUp">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"mulDivRoundingUp">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "mulDivRoundingUp",
        params
      );
    },
    configPath: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"configPath">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"configPath">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "configPath",
        params
      );
    },
    poolPath: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"poolPath">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"poolPath">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "poolPath",
        params
      );
    },
    poolContractId: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"poolContractId">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"poolContractId">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "poolContractId",
        params
      );
    },
    positionPath: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"positionPath">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"positionPath">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "positionPath",
        params
      );
    },
    positionContractId: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"positionContractId">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"positionContractId">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "positionContractId",
        params
      );
    },
    getSqrtRatioAtTick: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"getSqrtRatioAtTick">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"getSqrtRatioAtTick">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "getSqrtRatioAtTick",
        params
      );
    },
    getTickAtSqrtRatio: async (
      params: LiquidityManagmentTestTypes.SignExecuteMethodParams<"getTickAtSqrtRatio">
    ): Promise<
      LiquidityManagmentTestTypes.SignExecuteMethodResult<"getTickAtSqrtRatio">
    > => {
      return signExecuteMethod(
        LiquidityManagmentTest,
        this,
        "getTickAtSqrtRatio",
        params
      );
    },
  };

  async multicall<Calls extends LiquidityManagmentTestTypes.MultiCallParams>(
    calls: Calls
  ): Promise<LiquidityManagmentTestTypes.MultiCallResults<Calls>>;
  async multicall<Callss extends LiquidityManagmentTestTypes.MultiCallParams[]>(
    callss: Narrow<Callss>
  ): Promise<LiquidityManagmentTestTypes.MulticallReturnType<Callss>>;
  async multicall<
    Callss extends
      | LiquidityManagmentTestTypes.MultiCallParams
      | LiquidityManagmentTestTypes.MultiCallParams[]
  >(callss: Callss): Promise<unknown> {
    return await multicallMethods(
      LiquidityManagmentTest,
      this,
      callss,
      getContractByCodeHash
    );
  }
}
